import { render, staticRenderFns } from "./Page-Heading.vue?vue&type=template&id=7da85a51&scoped=true"
import script from "./Page-Heading.vue?vue&type=script&lang=ts"
export * from "./Page-Heading.vue?vue&type=script&lang=ts"
import style0 from "./Page-Heading.vue?vue&type=style&index=0&id=7da85a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da85a51",
  null
  
)

export default component.exports